import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {
  iconsSet as icons
} from './assets/icons/icons.js'
import store from './store'
import VueToasted from 'vue-toasted';
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import {
  authToken
} from './lib/httplib'
import VueClipboard from 'vue-clipboard2';
import CKEditor from 'ckeditor4-vue';
import { format } from 'date-fns'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard)
Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueToasted)
Vue.use(CKEditor)
Vue.prototype.$log = console.log.bind(console)
Vue.use(wysiwyg, {
  image: {
    uploadURL: process.env.VUE_APP_API_HOST + "/api/v1/file/upload-editor?resp=base64",
    dropzoneOptions: {
      headers: {
        'Authorization': 'Bearer ' + authToken(),
      },
    }
  },
});
Vue.filter('thousandSeparator', function (amount) {
  if (!amount) {
    return 0;
  }
  if (
    amount !== "" ||
    amount !== undefined ||
    amount !== 0 ||
    amount !== "0" ||
    amount !== null
  ) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return amount;
  }
});

const d = new Date();

Vue.filter('date', function (date) {
  if (!date) {
    return '';
  }
  date = new Date(date);
  return format(d, 'dd MMM yyyy');
});

Vue.filter('dateFormat', function (date) {
  if (!date) {
    return '';
  }
  date = new Date(date);
  if (typeof date == 'object') {
    return format(date, 'dd MMM yyyy')
  }
  return format(d, 'dd MMM yyyy');
});

Vue.filter('dateTimeFormat', function (date) {
  if (!date) {
    return '';
  }
  date = new Date(date);
  if (typeof date == 'object') {
    return format(date, 'dd MMM yyyy HH:mm:ss')
  }
  return format(d, 'dd MMM yyyy HH:mm:ss');
});

Vue.filter('timeFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return format(date, 'HH:mm:ss')
  }
  return format(d, 'HH:mm:ss');
});

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})